import styled from "styled-components";
import { deviceSpec } from "breakpoints";
import { Select, TextField, Typography, Grid, FormControlLabel, Button} from "@mui/material";


export const FormContainer = styled("form")`
    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 3em;
    height: 80%;
    padding: 1em;
`;

export const QuestionField = styled("div")`
    display: grid;
    padding-top: 1em;
`;

export const InputField = styled("input")`
    color: black;
    border: 1px solid black;
    height: 1.9em;
`;

export const ButtonContainer = styled("div")`
    padding-top: 2em;
`;

export const SelectWindow = styled("select")`
    border-style: solid;
    border-width: 2px;
    border-color: black;
    height: 9em;
`;

export const NextButton = styled("button")`
    height: 2.5em;
    color: white;
    background-color: #A100FF;
    border-radius: 20px;
    width: 7em;
    margin-left: auto;
`;

export const StaticFormPage = styled("div")`
    width: 30em;
    background: white;
    margin-left: auto;
    margin-right: auto;

`;

export const QuestionLabel = styled("label")`
    font-weight: bold;
    font-size: 12px;
    padding-bottom: .5em;
`;

export const DropdownQuestion = styled("select")`
    border: 1px solid black;
    height: 1.9em;
`;

export const FormHeader = styled("label")`
    font-weight: bold;
    font-size: 16px;
`;